'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _resources = require('redux/modules/resources');

var _reactRouter = require('react-router');

var _modules = require('redux/modules/modules');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Module1Act2 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, profile: state.profile.data, app: state.moduleData.data.module1.act2 };
}, (0, _extends3.default)({}, _resources.changeResource, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module1Act2, _Component);

  function Module1Act2() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module1Act2);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module1Act2.__proto__ || (0, _getPrototypeOf2.default)(Module1Act2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 1,
      appId: 2,
      title: 'Increase vegetable consumption',
      monday: _this.props.app.monday || false,
      tuesday: _this.props.app.tuesday || false,
      wednesday: _this.props.app.wednesday || false,
      thursday: _this.props.app.thursday || false,
      friday: _this.props.app.friday || false,
      saturday: _this.props.app.saturday || false,
      sunday: _this.props.app.sunday || false,
      offer: _this.props.app.offer || '', // radio - frequency of offer
      breakfast: _this.props.app.breakfast || false,
      lunch: _this.props.app.lunch || false,
      dinner: _this.props.app.dinner || false,
      snacks: _this.props.app.snacks || false,
      other: _this.props.app.other || false,
      likelyOffer: _this.props.app.likelyOffer || '', // text box
      doingDinner: _this.props.app.doingDinner || false,
      doingLunch: _this.props.app.doingLunch || false,
      doingTea: _this.props.app.doingTea || false,
      isCompleted: _this.props.app.isCompleted || false
    }, _this.handleComplete = function () {
      var obj = _this.state;
      obj.isCompleted = true;
      _this.setState(obj);

      _this.props.updateModuleAct(_this.props.user.userId, _this.state.moduleId, _this.state.appId, obj);

      _this.props.changeItem(_this.state.moduleId, 2, _this.state.appId + 1);
    }, _this.handleOffer = function (event) {
      var obj = _this.state;
      obj.offer = event.target.value;
      _this.setState(obj);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;

      if (str !== 'likelyOffer') {
        obj[str] = !obj[str];
      } else {
        obj[str] = event.target.value;
      }

      _this.setState(obj);
    }, _this.handleResourceClick = function (module, item, event) {
      console.log(event);
      _this.props.changeResource(module, item);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  /*
   * Handles when user clicks on if they have
   * offered vegetables throughout the day
   */


  /*
   * General function used to change state of object
   */


  // used to navigate to a resource item


  (0, _createClass3.default)(Module1Act2, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 1'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'h4',
            null,
            'Goal: Increase opportunity for vegetable consumption'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Overview of this goal and activity'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Reboot is based on the Healthy Habits program which was delivered to nearly 400 Australian families. The developers of the healthy habits program found that parent providing of fruit and vegetables was key to increasing children\u2019s fruit and vegetable intake. More importantly, it didn\u2019t matter whether the child ate the vegetable. What mattered was that the parent continued to offer the fruit or vegetables to their child whenever possible. Often it can take up to 20 exposures before children accept the new food.'
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'So that\'s what we\'re suggesting you try this week. If your child does not eat the vegetables you offer them, that\'s ok, just keep offerring them!'
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Keeping a record of the vegetables that ',
                this.props.profile.childName,
                ' is provided each day can be a helpful way of looking at how often you provide opportunities for ',
                this.props.profile.childName,
                ' to eat or become more familiar with different vegetables. '
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'You\u2019ll find in the ',
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: 'resourceslanding', onClick: this.handleResourceClick.bind(this, 1, 1) },
                  'Resources module of the app a Vegetable Providing Food Diary'
                ),
                '. You can either print this off  and keep it handy, transferring what you record into the app later or you can enter it straight into the app. We encourage you to try and record two weekdays and one day over the weekend before your next telephone consultation. For each eating occasion (e.g. breakfast), put a tick in the vegetable column if you offer your child a serve of fruit or vegies. Also, record if he or she accepted it. Here is an example:'
              )
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Table,
            { bordered: true, responsive: true },
            _react2.default.createElement(
              'thead',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'th',
                  null,
                  'Monday'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  'Vegetables offered'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  'Child accepted'
                )
              )
            ),
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  'Eg. Morning snack'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement('i', { className: styles.orangeText + ' fa fa-2x fa-check' }),
                  ' 1/2 cup chopped up carrots at school at 10am'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement('i', { className: styles.orangeText + ' fa fa-2x fa-check' }),
                  ' '
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  'Eg. Lunch'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement('i', { className: styles.orangeText + ' fa fa-2x fa-check' }),
                  ' A cheese sandwich filled with 1/2 cup grated lettuce, carrots and beetroot at 12pm'
                ),
                _react2.default.createElement('td', null)
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  'Eg. Afternoon snack'
                ),
                _react2.default.createElement('td', null),
                _react2.default.createElement('td', null)
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  'Eg. Dinner'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement('i', { className: styles.orangeText + ' fa fa-2x fa-check' }),
                  ' 1/2 cup of cooked pumpkin with chicken schnitzel at 6pm'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  '1/2 ',
                  _react2.default.createElement('i', { className: styles.orangeText + ' fa fa-2x fa-check' }),
                  ' '
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  'Eg. Snack'
                ),
                _react2.default.createElement('td', null),
                _react2.default.createElement('td', null)
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  'Total number of ticks'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  '3'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  '1 1/2'
                )
              )
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'Now let\'s look at any gaps'
          ),
          _react2.default.createElement(
            'h5',
            null,
            'Are there any mealtimes where you can start to add vegetables, offer different vegetables or increase the number of serves of vegetables?'
          ),
          _react2.default.createElement(
            'p',
            null,
            'We encourage you to record these below.'
          ),
          _react2.default.createElement(
            ReactBootstrap.Table,
            { bordered: true, responsive: true },
            _react2.default.createElement(
              'thead',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'th',
                  null,
                  'Answer'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  'Response'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  'Currently doing'
                )
              )
            ),
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  'Dinner'
                ),
                this.state.doingDinner && _react2.default.createElement(
                  'td',
                  null,
                  'Dinner is a great opportunity to provide some vegetables, by providing at least two serves during the main meal you\'ll ensure that your child has vegetables everyday. You can serve meat with vegetable sides, and you can add vegetables to stir-fries, mince and pasta dishes.'
                ),
                !this.state.doingDinner && _react2.default.createElement('td', null),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(ReactBootstrap.Checkbox, { bsSize: 'large', onChange: this.handleChange.bind(this, 'doingDinner'), checked: this.state.doingDinner === true })
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  'Lunchtime'
                ),
                this.state.doingLunch && _react2.default.createElement(
                  'td',
                  null,
                  'Fantastic! Lunch time is a great opportunity to provide some vegetables. Salad vegies such as tomato, cucumber and lettuce are great on sandwiches. You can also try avocado instead of butter (or margarine)'
                ),
                !this.state.doingLunch && _react2.default.createElement('td', null),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(ReactBootstrap.Checkbox, { onChange: this.handleChange.bind(this, 'doingLunch'), checked: this.state.doingLunch === true })
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  'Morning/afternoon tea'
                ),
                this.state.doingTea && _react2.default.createElement(
                  'td',
                  null,
                  'That\'s great. Vegetable snacks are cheaper and healthier than many of the processed chicken\'s snack foods. Kids often like cherry tomatoes and snow peas. You can make vegies more appealing by dipping stick of carrot, capsicum, celery or beans into low fat dip such as hummus or cottage cheese. You can also try avocado instead of butter/margarine.'
                ),
                !this.state.doingTea && _react2.default.createElement('td', null),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(ReactBootstrap.Checkbox, { onChange: this.handleChange.bind(this, 'doingTea'), checked: this.state.doingTea === true })
                )
              )
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            'What days do you think might work best for you to complete the food diary?'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Please select 3 days with at least 1 day from the weekend'
          ),
          _react2.default.createElement(
            ReactBootstrap.FormGroup,
            null,
            _react2.default.createElement(
              ReactBootstrap.Checkbox,
              { inline: true, onChange: this.handleChange.bind(this, 'monday'),
                checked: this.state.monday === true },
              'Monday'
            ),
            _react2.default.createElement(
              ReactBootstrap.Checkbox,
              { inline: true, onChange: this.handleChange.bind(this, 'tuesday'),
                checked: this.state.tuesday === true },
              'Tuesday'
            ),
            _react2.default.createElement(
              ReactBootstrap.Checkbox,
              { inline: true, onChange: this.handleChange.bind(this, 'wednesday'),
                checked: this.state.wednesday === true },
              'Wednesday'
            ),
            _react2.default.createElement(
              ReactBootstrap.Checkbox,
              { inline: true, onChange: this.handleChange.bind(this, 'thursday'),
                checked: this.state.thursday === true },
              'Thursday'
            ),
            _react2.default.createElement(
              ReactBootstrap.Checkbox,
              { inline: true, onChange: this.handleChange.bind(this, 'friday'),
                checked: this.state.friday === true },
              'Friday'
            ),
            _react2.default.createElement(
              ReactBootstrap.Checkbox,
              { inline: true, onChange: this.handleChange.bind(this, 'saturday'),
                checked: this.state.saturday === true },
              'Saturday'
            ),
            _react2.default.createElement(
              ReactBootstrap.Checkbox,
              { inline: true, onChange: this.handleChange.bind(this, 'sunday'),
                checked: this.state.sunday === true },
              'Sunday'
            )
          )
        ),
        _react2.default.createElement('div', { className: styles.spacer20 }),
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, sm: 12, lg: 12, xs: 12 },
          _react2.default.createElement(
            'p',
            null,
            'Now let\'s look at what you are currently doing.'
          ),
          _react2.default.createElement(
            'h5',
            { className: styles.orangeText },
            'Have you been trying to offer ',
            this.props.profile.childName,
            ' vegetables throughout the day?'
          ),
          _react2.default.createElement(
            ReactBootstrap.FormGroup,
            { onChange: this.handleOffer },
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'offer', value: 'always', inline: true, checked: this.state.offer === 'always' },
              'Always'
            ),
            ' ',
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'offer', value: 'most', inline: true, checked: this.state.offer === 'most' },
              'Most times'
            ),
            ' ',
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'offer', value: 'sometimes', inline: true, checked: this.state.offer === 'sometimes' },
              'Sometimes'
            ),
            ' ',
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'offer', value: 'other', inline: true, checked: this.state.offer === 'other' },
              'Other'
            )
          ),
          _react2.default.createElement(
            'h5',
            { className: styles.orangeText },
            'When do you offer vegetables?'
          ),
          _react2.default.createElement(
            ReactBootstrap.FormGroup,
            null,
            _react2.default.createElement(
              ReactBootstrap.Checkbox,
              { inline: true, onChange: this.handleChange.bind(this, 'breakfast'),
                checked: this.state.breakfast === true },
              'Breakfast'
            ),
            _react2.default.createElement(
              ReactBootstrap.Checkbox,
              { inline: true, value: this.state.Lunch, onChange: this.handleChange.bind(this, 'lunch'),
                checked: this.state.Lunch },
              'Lunch'
            ),
            _react2.default.createElement(
              ReactBootstrap.Checkbox,
              { inline: true, onChange: this.handleChange.bind(this, 'dinner'),
                checked: this.state.dinner === true },
              'Dinner'
            ),
            _react2.default.createElement(
              ReactBootstrap.Checkbox,
              { inline: true, onChange: this.handleChange.bind(this, 'snacks'),
                checked: this.state.snacks === true },
              'Snacks'
            ),
            _react2.default.createElement(
              ReactBootstrap.Checkbox,
              { inline: true, onChange: this.handleChange.bind(this, 'other'),
                checked: this.state.other === true },
              'Other'
            )
          ),
          _react2.default.createElement(
            'h5',
            { className: styles.orangeText },
            'Are there places or activities where ',
            this.props.profile.childName,
            ' is more likely to be offered vegetables or eat vegetables?'
          ),
          _react2.default.createElement(
            ReactBootstrap.FormGroup,
            null,
            _react2.default.createElement(ReactBootstrap.FormControl, { type: 'text', placeholder: 'Record some of these details',
              value: this.state.likelyOffer, onChange: this.handleChange.bind(this, 'likelyOffer') })
          ),
          _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete }),
          _react2.default.createElement('div', { className: styles.spacer40 })
        )
      );
    }
  }]);
  return Module1Act2;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  profile: _propTypes2.default.object,
  changeResource: _propTypes2.default.func,
  changeItem: _propTypes2.default.func,
  updateModuleAct: _propTypes2.default.func,
  app: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module1Act2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/1/Activities/Act2.js
// module id = 1161
// module chunks = 0